export default {
  name: "SensitivitySelector",

  props: ["errors", "defaultSensitivity", "sensitivities"],

  data() {
    return {
      sensitivity: null,
    };
  },
  methods: {
    sensitivitySelected() {
      this.$emit("sensitivitySelected", {
        sensitivity: this.sensitivity,
      });
    }
  },
  created() {
    // eslint-disable-next-line no-console
    this.sensitivity = this.defaultSensitivity;
    // eslint-disable-next-line no-console
  },
  watch: {
    defaultSensitivity() {
      this.sensitivity = this.defaultSensitivity;
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/_sensitivity-selector/sensitivity-selector.js